





import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'SbQuote',
  props: {
    content: {
      type: Array,
      required: true,
    },
  },

  computed: {
    richTextContent(): Record<string, unknown> {
      return {
        type: 'doc',
        content: this.content,
      };
    },
  },
});
